module.exports = __webpack_public_path__ + "img/my-trips.9e133120.svg";